import { memo } from "react";
import Answer from "./Answer";
import AnswerDateRange from "./AnswerDateRange";
import AnswerDD from "./AnswerDD";
import AnswerRadio from "./AnswerRadio";
import AnswerTracker from "./AnswerTracker";
import { Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import AnswerRecommendation from "./AnswerRecommendation";
import AnswerLocation from "./AnswerLocation";

const RenderAnswer = ({ answer, question, containerStyles = globalStyles.reportQuestionOuter, wrapContainer = true, ...props }) => {
  const hideAnswer = answer?.answer?.other_details?.visibility == "hidden";
  return (
    !hideAnswer && (
      <View wrap={wrapContainer}>
        {/* {question?.question_type} */}
        {props.showQuestion !== false && (
          <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "4px" }}>
            <Text style={{ ...props.styles.mainSubHeading }}>{question?.question}</Text>
          </View>
        )}
        {question?.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location ? (
          <AnswerLocation
            answer={answer}
            question={question}
            {...props}
          />
        ) : question?.question_type === "textarea_radio" ? (
          <AnswerRadio
            answer={answer}
            question={question}
            {...props}
          />
        ) : question?.question_type === "textarea_dd" ? (
          <AnswerDD
            answer={answer}
            question={question}
            {...props}
          />
        ) : question?.question_type === "date" ? (
          <AnswerDateRange
            answer={answer}
            {...props}
          />
        ) : question?.question_type === "tracker" ? (
          <AnswerTracker
            answer={answer}
            question={question}
            {...props}
          />
        ) : question?.question_type === "template" ? (
          question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.recommendation ? (
            <AnswerRecommendation
              answer={answer}
              question={question}
              {...props}
            />
          ) : (
            null
          )
        ) : (
          <Answer
            answer={answer}
            {...props}
          />
        )}
      </View>
    )
  );
};

export const RenderAnswerByQId = memo(function ({ questionId, reportQuestions, reportAnswers, ...props }) {
  const question = reportQuestions?.length && reportQuestions?.find((q) => q.id === questionId);
  const answer = reportAnswers?.length && reportAnswers?.find((a) => a.question_id === questionId);
  if (questionId == 94) {
    console.log("QUESTION OF RECCO", reportAnswers)
  }
  return (
    <RenderAnswer
      answer={answer}
      question={question}
      {...props}
    />
  )
});

export default RenderAnswer;